import script from "./SeeMoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SeeMoreButton.vue?vue&type=script&setup=true&lang=js"

import "./SeeMoreButton.vue?vue&type=style&index=0&id=508764a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508764a3"]])

export default __exports__